import script from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMemberModal.vue?vue&type=style&index=0&id=6da2c934&lang=scss&scoped=true"
script.__scopeId = "data-v-6da2c934"

export default script